import { useTranslation } from 'react-i18next';

import LinkContainer from './LinkContainer';
import LinkRow from './LinkRow';

function NewsContents() {
    const { t } = useTranslation('main', { keyPrefix: 'sidebar.news' });
    return (
        <LinkContainer title={t('title')}>
            <LinkRow label={t('event')} activityName='BoardActivity'
                activityParams={{ type: 'EVENT' }}/>
            <LinkRow label={t('notice')}
                activityParams={{ type: 'NOTICE' }}
                activityName='BoardActivity'/>
        </LinkContainer>
    );
}

export default NewsContents;
